import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(100%)',
      opacity: 0,
    },
    '30%': {
      opacity: 0.3,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
  container: {
    display: 'flex',
    width: '100%',
    maxWidth: '1000px',
    height: 'auto',
    margin: '2rem auto',
    position: 'relative',
    overflow: 'visible',
    '&::before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `linear-gradient(135deg,
        #ffffff 0%,
        #fafafa 25%,
        #f8f9fa 50%,
        #f5f7fa 75%,
        #f2f4f7 100%
      )`,
      zIndex: -1,
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      maxWidth: '600px',
      margin: '1rem auto',
    },
  },
  content: {
    flex: '1 1 auto',
    backgroundColor: '#ffffff',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 6),
    order: 2,
    borderRadius: '0 16px 16px 0',
    position: 'relative',
    zIndex: 1,
    boxShadow: '-6px 0 10px -6px rgba(0, 0, 0, 0.15)',
    maxWidth: '600px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 3),
      order: 1,
      borderRadius: '16px 16px 0 0',
      boxShadow: '0 -6px 10px -6px rgba(0, 0, 0, 0.15)',
      maxWidth: '100%',
    },
  },
  summary: {
    width: '320px',
    height: 'auto',
    padding: theme.spacing(4),
    position: 'sticky',
    top: '2rem',
    order: 1,
    borderRadius: '16px 0 0 16px',
    background: `linear-gradient(180deg,
      rgba(1, 70, 81, 0.85) 0%,
      rgba(1, 70, 81, 0.90) 20%,
      rgba(1, 70, 81, 0.95) 40%,
      rgba(1, 70, 81, 0.98) 60%,
      rgba(1, 70, 81, 1) 80%,
      rgb(0, 55, 64) 100%
    )`,
    boxShadow: '0 4px 24px rgba(1, 70, 81, 0.25)',
    backdropFilter: 'blur(12px)',
    color: '#FFFFFF',
    animation: '$slideIn 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
    transformOrigin: 'right center',
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      color: '#FFFFFF',
      fontWeight: 600,
      marginBottom: theme.spacing(2),
    },
    '& p': {
      color: 'rgba(255, 255, 255, 0.9)',
      fontSize: '0.95rem',
      lineHeight: 1.5,
    },
    '& label': {
      color: 'rgba(255, 255, 255, 0.9)',
    },
    '& .MuiDivider-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
      margin: theme.spacing(2, 0),
    },
    '& .MuiTypography-root': {
      color: '#FFFFFF',
    },
    '& .MuiTypography-secondary': {
      color: 'rgba(255, 255, 255, 0.7)',
    },
    '& .amount': {
      color: '#4CFFB3',
      fontWeight: 600,
    },
    '& .detail-label': {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: '0.875rem',
      marginBottom: theme.spacing(0.5),
    },
    '& .detail-value': {
      color: '#FFFFFF',
      fontSize: '1rem',
      fontWeight: 500,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '600px',
      position: 'relative',
      height: 'auto',
      top: 0,
      order: 0,
      borderRadius: '16px 16px 0 0',
      animation: '$slideIn 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
      margin: '0 auto',
      background: `linear-gradient(180deg,
        rgba(1, 70, 81, 0.85) 0%,
        rgba(1, 70, 81, 0.90) 20%,
        rgba(1, 70, 81, 0.95) 40%,
        rgba(1, 70, 81, 0.98) 60%,
        rgba(1, 70, 81, 1) 80%,
        rgb(0, 55, 64) 100%
      )`,
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
    textAlign: 'center',
    '& h2': {
      color: theme.palette.error.main,
      marginBottom: theme.spacing(2),
    },
    '& p': {
      color: theme.palette.text.secondary,
    },
  },
}));
